import { DynamicLayout } from '../../formbuilder';
import { newStepValue } from '../../../../services/flowBuilder/utils/constants';
import { redis } from './redis';
import { regularExpression } from './regularExpression';
import { encryption } from './encryption';
import { httpCall } from './httpCall';
import { waitForCallback } from './waitForCallback';
import { setVariable } from './variable-node';
import { chatHub } from './chatHub';
import { switchCase } from './switchCase';

const isEmpty = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'isEmpty',
      actionParams: {
        variableName: '',
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.variableName',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: ['action.name', 'action.description', 'action.actionParams.variableName'],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    variableName: {
      type: 'text',
      label: 'Variable Name',
      validators: {
        required: true,
      },
    },
    result: {
      dataType: 'keyValue',
      key: {
        attributes: {
          readonly: true,
        },
        type: 'text',
        label: '#',
      },
      value: {
        attributes: {
          // readonly: false
        },
        type: 'next',
        label: 'Point to',
      },
    },
  },
};

const remap = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'remap',
      actionParams: {
        remapValues: {
          '': '',
        },
        valueToRemap: '',
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.valueToRemap',
    'action.actionParams.remapValues.#',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: ['action.name', 'action.description', 'action.actionParams.valueToRemap'],
    },
    {
      Values: ['action.actionParams.remapValues.#'],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    valueToRemap: {
      type: 'text',
      label: 'Value To Remap',
      validators: {
        required: true,
      },
    },
    remapValues: {
      dataType: 'keyValue',
      attributes: {
        add: true,
        delete: true,
        class: 'keyValuePairRow',
      },
      key: {
        type: 'text',
        label: 'key',
        placeholder: 'Key',
        validators: {
          required: true,
        },
      },
      value: {
        type: 'text',
        label: 'value',
        placeholder: 'Value',
        validators: {
          required: true,
        },
      },
    },
    result: {
      dataType: 'keyValue',
      key: {
        attributes: {
          readonly: true,
        },
        type: 'text',
        label: '#',
      },
      value: {
        attributes: {
          // readonly: false
        },
        type: 'next',
        label: 'Point to',
      },
    },
  },
  data: {
    remapValues: {
      '': '',
    },
  },
};

const dateFormat = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'dateFormat',
      actionParams: {
        variableName: '',
        patternFrom: '',
        patternTo: '',
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.variableName',
    'action.actionParams.patternFrom',
    'action.actionParams.patternTo',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: [
        'action.name',
        'action.description',
        'action.actionParams.variableName',
        'action.actionParams.patternFrom',
        'action.actionParams.patternTo',
      ],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    variableName: {
      type: 'text',
      label: 'Variable Name',
      validators: {
        required: true,
      },
    },
    patternFrom: {
      type: 'text',
      label: 'Pattern From',
      validators: {
        required: true,
      },
    },
    patternTo: {
      type: 'text',
      label: 'Pattern To',
      validators: {
        required: true,
      },
    },
    result: {
      dataType: 'keyValue',
      key: {
        attributes: {
          readonly: true,
        },
        type: 'text',
        label: '#',
      },
      value: {
        attributes: {
          // readonly: false
        },
        type: 'next',
        label: 'Point to',
      },
    },
  },
};

const numberFormat = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'decimalFormat',
      actionParams: {
        variableName: '',
        pattern: '',
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.variableName',
    'action.actionParams.pattern',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: [
        'action.name',
        'action.description',
        'action.actionParams.variableName',
        'action.actionParams.pattern',
      ],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    variableName: {
      type: 'text',
      label: 'Variable Name',
      validators: {
        required: true,
      },
    },
    pattern: {
      type: 'text',
      label: 'Pattern',
      validators: {
        required: true,
      },
    },
    result: {
      dataType: 'keyValue',
      key: {
        attributes: {
          // readonly: true
        },
        type: 'text',
        label: '#',
      },
      value: {
        attributes: {
          // readonly: false
        },
        type: 'next',
        label: 'Point to',
      },
    },
  },
};

const displayList = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'displayList',
      actionParams: {
        pattern: '',
        listNumbers: true,
        indexPattern: '#',
        filterBy: {
          '': '',
        },
        exclude: {
          '': '',
        },
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.pattern',
    'action.actionParams.listNumbers',
    'action.actionParams.indexPattern',
    'action.actionParams.filterBy.#',
    'action.actionParams.exclude.#',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: [
        'action.name',
        'action.description',
        'action.actionParams.pattern',
        'action.actionParams.listNumbers',
        'action.actionParams.indexPattern',
        'action.actionParams.filterBy.#',
        'action.actionParams.exclude.#',
      ],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
  layout: {
    filterBy: {
      dataType: 'keyValue',
      label: 'Filter By',
      key: {
        type: 'text',
        label: '',
        placeholder: 'Pattern',
      },
      value: {
        type: 'text',
        label: '',
        placeholder: 'Value',
      },
      attributes: {
        //   add: true
        class: 'keyValuePairRow FilterBy',
      },
    },
    exclude: {
      dataType: 'keyValue',
      label: 'Exclude',
      key: {
        type: 'text',
        label: '',
        placeholder: 'Pattern',
      },
      value: {
        type: 'text',
        label: 'Point to',
        placeholder: 'Value',
      },
      attributes: {
        //   add: true
        class: 'keyValuePairRow Exclude',
      },
    },
    indexPattern: {
      type: 'text',
      label: 'Custom Index',
      validators: {
        required: true,
      },
    },
    listNumbers: {
      type: 'checkbox-single',
      label: 'List Numbers',
      // attributes: {
      //   add: true
      // }
    },
    pattern: {
      type: 'text',
      label: 'Pattern',
      validators: {
        required: true,
      },
    },
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    result: {
      dataType: 'keyValue',
      key: {
        attributes: {
          readonly: true,
        },
        type: 'text',
        label: '#',
      },
      value: {
        attributes: {
          // readonly: false
        },
        type: 'next',
        label: 'Point to',
      },
    },
  },
  // data: {
  //   filterBy: '$',
  //   exclude: '$'
  // }
};

const isNull: DynamicLayout = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'isNull',
      actionParams: {
        variableName: '',
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.variableName',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: ['action.name', 'action.description', 'action.actionParams.variableName'],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    variableName: {
      type: 'text',
      label: 'Variable Name',
      validators: {
        required: true,
      },
    },
    result: {
      dataType: 'keyValue',
      key: {
        attributes: {
          readonly: true,
        },
        type: 'text',
        label: '#',
      },
      value: {
        attributes: {
          // readonly: false
        },
        type: 'next',
        label: 'Point to',
      },
    },
  },
};

const math: DynamicLayout = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'math',
      actionParams: {
        variables: {
          '': '',
        },
        expression: '',
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
        error: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.expression',
    'action.actionParams.variables.#',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: ['action.name', 'action.description', 'action.actionParams.expression'],
    },
    {
      Variables: ['action.actionParams.variables.#'],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    variables: {
      dataType: 'keyValue',
      type: 'text',
      label: '',
      attributes: {
        add: true,
        delete: true,
        class: 'keyValuePairRow',
      },
      key: {
        type: 'text',
        label: '',
        placeholder: 'Key',
        validators: {
          required: true,
        },
      },
      value: {
        type: 'text',
        label: '',
        placeholder: 'Value',
        validators: {
          required: true,
        },
      },
    },
    expression: {
      type: 'text',
      label: 'Expression',
      validators: {
        required: true,
        noSpaces: true,
      },
    },
    result: {
      dataType: 'keyValue',
      key: {
        attributes: {
          readonly: true,
        },
        type: 'text',
        label: '#',
      },
      value: {
        attributes: {
          // readonly: false
        },
        type: 'next',
        label: 'Point to',
      },
    },
  },
};

export const actionTypes = {
  dateFormat: dateFormat,
  decimalFormat: numberFormat,
  displayList: displayList,
  isEmpty: isEmpty,
  remap: remap,
  math: math,
  isNull: isNull,
  switchCase: switchCase,
  redis: redis,
  regularExpression: regularExpression,
  httpCall: httpCall,
  encrypt: encryption,
  waitForCallback: waitForCallback,
  setVariable: setVariable,
  chatHub: chatHub
};
